// extracted by mini-css-extract-plugin
export default {"fields":"JKMdo67QsYmq032jMhn2"};